import {Serializers} from '../../interfaces/serializer';
import {DataSetMetricsGroup} from '../../interfaces/metrics';
import {DatasetMetricsGroupComponentObjects} from '../../classes/dataset-metrics-group-component-object';

export const DATASET_METRICS_GROUPS_STATE_NAME = 'datasetMetricsGroups';

export interface DataSetMetricsGroupsState {
  serialized: Serializers<DataSetMetricsGroup>;
  componentObjects: DatasetMetricsGroupComponentObjects;
  loading: boolean;
  loaded: boolean;
  initialized: boolean;
}
